/**
 * Constants for MsSplitButton component
 * Extracted from original component for better maintainability
 */

export const VALID_BUTTON_TYPES = [
  'primary',
  'secondary', 
  'third',
  'four'
]

export const DEFAULT_PROPS = {
  text: null,
  leftIcon: null,
  rightIcon: 'chevron-down-white',
  type: 'primary',
  disabled: false,
  menuItems: [],
  classCustom: '',
  customPositionMenu: false,
  customWidth: 0,
  heightOffset: 5,
  widthOffset: 25,
  hasShowMenu: true,
  tooltipText: null,
  hasBorder: false,
  hasBorderParent: false
}

export const SPLIT_BUTTON_EVENTS = [
  'primaryClick',
  'menuClick'
]

export const CSS_CLASSES = {
  SPLIT_BUTTON: 'split-button',
  FLEX_CENTER: 'flex-center',
  BORDER_SPLIT_BTN: 'border-split-btn',
  PRIMARY_BUTTON: 'btn flex-row primary-button',
  BTN_BORDER_NONE: 'btn-border-none',
  ICON24: 'icon24',
  ICON_LEFT: 'icon left',
  TEXT: 'text',
  TEXT_PL_0: 'pl-0',
  WIDGET_MORE_CONTAINER: 'widget-more-container widget-btn',
  WIDGET_MORE: 'widget-more'
}

// Typo từ component gốc - giữ nguyên để backward compatible
export const PROP_TYPOS = {
  defualt: 'default' // typo trong prop text.defualt
}
